import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { ReceiptIcon } from '../assets';
import Typography from '../typography/Typography';
import { IconWrapper, ReceiptButton } from './styles';
const DownloadButton = ({ title, link }) => {
    const { colors } = useTheme();
    return (_jsxs(ReceiptButton, { href: link, target: "_blank", download: true, children: [_jsx(IconWrapper, { color: colors.interactive.brandColor, children: _jsx(ReceiptIcon, {}) }), _jsx(Typography, { type: "subHeadline", fontFamily: "primaryMedium", children: title })] }));
};
export default DownloadButton;
//# sourceMappingURL=DownloadButton.js.map